import watchGetPhoto from './getPhoto';

const watchUserAvatar = [watchGetPhoto];

export default watchUserAvatar;
